enum StorageTypes {
	cookie,
	sessionStorage,
	localStorage,
}

export default StorageTypes
